import {
    onIdTokenChanged,
    signInWithEmailAndPassword,
    signOut as firebaseSignOut,
} from 'firebase/auth';
import { auth } from './Firebase';

let currentToken = null;
let currentUser = null;

// Kept in sync automatically — Firebase proactively refreshes the ID token
// (roughly every 55 minutes) and fires this on sign-in/out too.
onIdTokenChanged(auth, async (user) => {
    currentUser = user;
    currentToken = user ? await user.getIdToken() : null;
});

export const getToken = () => currentToken;
export const getCurrentUser = () => currentUser;

export const login = (email, password) => signInWithEmailAndPassword(auth, email, password);
export const logout = () => firebaseSignOut(auth);

// Resolves once with the current signed-in user (or null) after Firebase has finished
// restoring session state — used so the app doesn't briefly flash the login screen (or
// fire authed API calls with no token yet) while that restoration is still in flight.
export const waitForAuthReady = () =>
    new Promise((resolve) => {
        const unsubscribe = onIdTokenChanged(auth, async (user) => {
            unsubscribe();
            resolve(user);
        });
    });
